{
  "metadata": {
    "id": "blood-moon-dark",
    "name": "Blood Moon",
    "description": "Собственная тема Synth «Blood Moon» (dark)",
    "author": "Synth",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "synth",
      "own"
    ],
    "source": {
      "file": "tools/lib/make_themes.py",
      "project": "synth",
      "url": null,
      "upstreamFile": null,
      "license": "собственная (Synth)",
      "authoring": "tools/lib/make_themes.py"
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 24.7,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.44,
      "paletteMaxS": 0.504,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.2,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 18.3,
      "syntaxVsTextMinDeltaE": 23.9,
      "chartsMinDeltaE": 25.9,
      "textSeparationDeltaE": 23.9,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "keyword",
          "b": "function",
          "deltaE": 11.2
        },
        {
          "a": "string",
          "b": "type",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#a73b3b",
      "hover": "#b25353",
      "active": "#b96262",
      "foreground": "#ffffff",
      "muted": "#a73b3b80",
      "emphasis": "#a73b3b"
    },
    "surface": {
      "background": "#140E0E",
      "foreground": "#E8DCD8",
      "muted": "#2b2423",
      "mutedForeground": "#a89a96",
      "elevated": "#342d2c",
      "elevatedForeground": "#E8DCD8",
      "raised": "#4f4745",
      "raisedForeground": "#E8DCD8",
      "overlay": "#140e0ecc",
      "subtle": "#211b1a"
    },
    "interactive": {
      "border": "#514948",
      "borderHover": "#4f4847",
      "borderFocus": "#a73b3b",
      "selection": "#e8dcd829",
      "selectionForeground": "#E8DCD8",
      "focus": "#a73b3b59",
      "focusRing": "#a73b3b61",
      "cursor": "#f7efec",
      "hover": "#e8dcd81c",
      "active": "#e8dcd829"
    },
    "status": {
      "error": "#d44e40",
      "errorForeground": "#000000",
      "errorBackground": "#d44e4024",
      "errorBorder": "#d44e4073",
      "warning": "#D08C3F",
      "warningForeground": "#000000",
      "warningBackground": "#d08c3f24",
      "warningBorder": "#d08c3f73",
      "success": "#7F9A6B",
      "successForeground": "#000000",
      "successBackground": "#7f9a6b24",
      "successBorder": "#7f9a6b73",
      "info": "#8A7FA8",
      "infoForeground": "#000000",
      "infoBackground": "#8a7fa824",
      "infoBorder": "#8a7fa873"
    },
    "pr": {
      "open": "#7F9A6B",
      "draft": "#a89a96",
      "blocked": "#D08C3F",
      "merged": "#C4564E",
      "closed": "#d44e40"
    },
    "syntax": {
      "base": {
        "background": "#38302f",
        "foreground": "#E8DCD8",
        "comment": "#a99870",
        "keyword": "#d58580",
        "string": "#C9A227",
        "number": "#e48c67",
        "function": "#d38484",
        "variable": "#E8DCD8",
        "type": "#C9A227",
        "operator": "#A89A96"
      },
      "tokens": {
        "commentDoc": "#a99870",
        "stringEscape": "#A89A96",
        "keywordImport": "#d58580",
        "storageModifier": "#d58580",
        "functionCall": "#d38484",
        "method": "#d38484",
        "variableProperty": "#d38484",
        "variableOther": "#E8DCD8",
        "variableGlobal": "#e48c67",
        "variableLocal": "#A89A96",
        "parameter": "#E8DCD8",
        "constant": "#e48c67",
        "class": "#C9A227",
        "className": "#C9A227",
        "interface": "#C9A227",
        "struct": "#C9A227",
        "enum": "#C9A227",
        "typeParameter": "#C9A227",
        "namespace": "#C9A227",
        "module": "#d58580",
        "tag": "#d58580",
        "jsxTag": "#d58580",
        "tagAttribute": "#d38484",
        "tagAttributeValue": "#C9A227",
        "boolean": "#e48c67",
        "decorator": "#d58580",
        "label": "#d38484",
        "regexp": "#C9A227"
      }
    },
    "charts": {
      "series": [
        "#a73b3b",
        "#8A7FA8",
        "#7F9A6B",
        "#D08C3F",
        "#f27b22"
      ]
    },
    "chat": {
      "background": "#140E0E",
      "userMessage": "#E8DCD8",
      "userMessageBackground": "#342d2c",
      "assistantMessage": "#E8DCD8",
      "assistantMessageBackground": "#2b2423",
      "timestamp": "#a89a96",
      "divider": "#514948",
      "typing": "#a89a96"
    },
    "loading": {
      "spinner": "#a73b3b",
      "spinnerTrack": "#2b2423",
      "skeleton": "#2b2423",
      "shimmer": "#433a39"
    },
    "tools": {
      "background": "#2b2423",
      "border": "#514948",
      "headerHover": "#413937",
      "icon": "#c55a5a",
      "title": "#E8DCD8",
      "description": "#a89a96",
      "edit": {
        "added": "#7F9A6B",
        "addedBackground": "#7f9a6b24",
        "removed": "#d44e40",
        "removedBackground": "#d44e4024",
        "modified": "#8A7FA8",
        "modifiedBackground": "#8a7fa824",
        "lineNumber": "#a89a96"
      }
    },
    "markdown": {
      "heading1": "#E8DCD8",
      "heading2": "#E8DCD8",
      "heading3": "#E8DCD8",
      "heading4": "#E8DCD8",
      "link": "#c55a5a",
      "linkHover": "#ba6565",
      "inlineCode": "#C9A227",
      "inlineCodeBackground": "#2b2423",
      "blockquote": "#a89a96",
      "blockquoteBorder": "#514948",
      "listMarker": "#ab3c3c",
      "bold": "#E8DCD8",
      "italic": "#e8dcd8e6",
      "strikethrough": "#a89a96",
      "hr": "#514948"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#bc7161",
        "foreground": "#000000",
        "contrast": 5.67
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#c9a78f",
        "foreground": "#000000",
        "contrast": 9.41
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#c3914b",
        "foreground": "#000000",
        "contrast": 7.47
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#aac755",
        "foreground": "#000000",
        "contrast": 11.01
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#b2cb92",
        "foreground": "#000000",
        "contrast": 11.85
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#53c552",
        "foreground": "#000000",
        "contrast": 9.48
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#5db070",
        "foreground": "#000000",
        "contrast": 7.91
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#66ccb7",
        "foreground": "#000000",
        "contrast": 10.89
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#4fabc2",
        "foreground": "#000000",
        "contrast": 7.94
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#598cc5",
        "foreground": "#000000",
        "contrast": 5.98
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#4e54a7",
        "foreground": "#ffffff",
        "contrast": 6.67
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#5d41b9",
        "foreground": "#ffffff",
        "contrast": 7.19
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#a87fd1",
        "foreground": "#000000",
        "contrast": 6.62
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#c049bb",
        "foreground": "#000000",
        "contrast": 4.91
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#b56893",
        "foreground": "#000000",
        "contrast": 5.37
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#be455c",
        "foreground": "#ffffff",
        "contrast": 5.01
      }
    ]
  }
}
